// TODO ja.tsを英訳して作成（需要があれば）
export const en = {
  service_name: "SECOM Sights",
  app_name: "Individual kitting",
  label: {
    construct_id: "Construction ID",
    password: "Password",
  },
  btn: {
    login: "Login",
    logout: "Logout",
  },
  msg: {
    timeout: "A timeout has occurred. Please log in again.",
    auth_error: "Incorrect construction ID or password.",
  },
};
